import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import CargoAllocationService from './../../services/cargoallocation.service';

export default {
  name: 'changedefaulthub',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect
  },
  props: [],
  data: function() {
    return {
      hubid:"",
      isLoading:false,
      currentHubName:"",
      hubaccessObjArray:[],
      hubaccess:[],
      currentHub:''
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.currentHub = userdetail.hubID[0];
    this.loadAllHubAccessList();
  },
  methods: {
    customLabel ({ hubname, hubid}) {
      return `${hubname} (${hubid})`
    },
    async loadAllHubAccessList() {
      try {
        let InputPayload = {
            userid: this.localuserid
        };
        this.isLoading = true;
        let response = await CargoAllocationService.getHubAccessList(InputPayload);
        this.isLoading = false;
        if(response.data.code===200){
          this.hubaccess = response.data.data.hubaccess;
          for (var i = 0; i < this.hubaccess.length; i++) {
            this.hubaccessObjArray.push({
              hubid: this.hubaccess[i].HubID,
              hubname: this.hubaccess[i].HubName
            })
          }
          let getcurrenthubobj = this.hubaccess.find(hubs => hubs.HubID == this.currentHub );
          this.hubid = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
        }
        else {
          this.$alertify.error(response.data.message);
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async changeHubTodefaultHub(event) {
      try {
        let InputPayload = {
            userid: this.localuserid,
            currentHub: this.hubid.hubid
        };
        this.isLoading = true;
        let response = await CargoAllocationService.updateCurrentHub(InputPayload);
        this.isLoading = false;
        if(response.data.code == 200){
          let getuserdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
          let getbytes  = CryptoJS.AES.decrypt(getuserdetailEncrypt.toString(), 'Key');
          let getplaintext = getbytes.toString(CryptoJS.enc.Utf8);
          let userdetail =JSON.parse(getplaintext);
          userdetail.hubID[0] = this.hubid.hubid;
          this.currentHub = this.hubid.hubid;
          this.currentHubName = this.hubid.hubname;
          userdetail.currentHubName = this.currentHubName;

          let setusersEncrupt = CryptoJS.AES.encrypt(JSON.stringify(userdetail), "Key");
          window.localStorage.setItem('cargoAutoaccessuserdata', setusersEncrupt);
          this.$alertify.success("Hub changed successfully !");
          location.reload();
        }
        else {
          this.$alertify.error(response.data.message);
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    resetForm() {
      this.hubid = '';
      this.$validator.reset();
      this.errors.clear();
      this.loadAllHubAccessList();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.changeHubTodefaultHub(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargoallocation/views/changedefaulthub/changedefaulthub.component.js